import envData from '../configuration/envConfig.json';

const hostnameToEnv = {
  'radnor.thingtrax.com': 'radnor',
  'knc.thingtrax.com': 'knc',
  'mbc.thingtrax.com': 'mbc',
  'ypm.thingtrax.com': 'ypm',
  'ypm2.thingtrax.com': 'ypm2',
  'demo.thingtrax.com': 'demo',
  'demov2.thingtrax.com': 'demov2',
  'acp.thingtrax.com': 'acp',
  'mgs.thingtrax.com': 'mgs',
  'rge.thingtrax.com': 'rge',
  'villagebakery.thingtrax.com': 'villagebakery',
  'zertusukheckington.thingtrax.com': 'zertusukheckington',
  'cranswick-watton.thingtrax.com': 'cranswick-watton',
  'bradburyscheese.thingtrax.com': 'bradburyscheese',
  'butlersfarmhousecheeses.thingtrax.com': 'butlersfarmhousecheeses',
  'rg.thingtrax.com': 'rg',
  'uat.thingtrax.com': 'uat',
  'uatq2.thingtrax.com': 'uatq2',
  'rgeyate.thingtrax.com': 'rgeyate',
  'ams.thingtrax.com': 'ams',
  'whs.thingtrax.com': 'whs',
  'rgebaltic.thingtrax.com': 'rgebaltic',
  'rpc.thingtrax.com': 'rpc',
  'rpca.thingtrax.com': 'rpca',
  'ecsebeta.thingtrax.com': 'essentra',
  'jilanibeta.thingtrax.com': 'jilani',
  'popularpipe.thingtrax.com': 'popularpipe',
  'polyplast.thingtrax.com': 'polyplast',
  'skl.thingtrax.com': 'skl',
  'stl.thingtrax.com': 'stl',
  'stlv2.thingtrax.com': 'stlv2',
  'seipl.thingtrax.com': 'seipl',
  'test.thingtrax.com': 'test',
  'devops.thingtrax.com': 'devops',
  'erpdev.thingtrax.com': 'erpdev',
  'pa.thingtrax.com': 'pa',
  'finsbury.thingtrax.com': 'finsbury',
  'preprod.thingtrax.com': 'preprod',
  'deschuk.thingtrax.com': 'deschuk',
  '192.168.1.137': 'lahoreoffice',
  'mainetti.thingtrax.com': 'mainetti',
  'carclo-mitcham.thingtrax.com': 'carclo-mitcham',
  'carclo-latrobe.thingtrax.com': 'carclo-latrobe',
  'carclo-export.thingtrax.com': 'carclo-export',
  'carclo-az.thingtrax.com': 'carclo-tucson',
  'carclo-taicang.thingtrax.com': 'carclo-taicang',
  'pvluk.thingtrax.com': 'pvluk',
  'bpia.thingtrax.com': 'bpia',
  'cs.thingtrax.com': 'cs',
  'salesdemo.thingtrax.com': 'salesdemo',
  'baudev.thingtrax.com': 'baudev',
  'csuite.thingtrax.com': 'csuite',
  'cedo.thingtrax.com': 'cedo',
  'dms.thingtrax.com': 'dms',
  'kc.thingtrax.com': 'kc',
  'ipppol.thingtrax.com': 'ipppol',
  'gen2carbon.thingtrax.com': 'gen2carbon',
  'cpr.thingtrax.com': 'cpr',
  'talon.thingtrax.com': 'talon',
  'whspickering.thingtrax.com': 'xandor',
  'atkore.thingtrax.com': 'atkore',
  'severfield.thingtrax.com': 'severfield',
  'aimia.thingtrax.com': 'aimia',
  'carclo-india.thingtrax.com': 'carclo-india',
  'chenhsong.thingtrax.com': 'chenhsong',
  'chenhsongfr.thingtrax.com': 'chenhsongfr',
  'cyient.thingtrax.com': 'cyient',
  'carclo-czech.thingtrax.com': 'carclo-czech',
  'carclo-derry.thingtrax.com': 'carclo-derry',
  'southern-champion.thingtrax.com': 'southern-champion',
  'mccolgans.thingtrax.com': 'mccolgans',
  'qa.thingtrax.com': 'qa',
  'quin.thingtrax.com': 'quin',
  'delifrance.thingtrax.com': 'delifrance',
  'q2.thingtrax.com': 'q2',
  'stonegate.thingtrax.com': 'stonegate',
  'aquascot.thingtrax.com': 'aquascot',
  'oms.thingtrax.com': 'oms',
  'hfuk.thingtrax.com': 'hfuk',
  'kpl.thingtrax.com': 'kpl',
  'sofinahull.thingtrax.com': 'sofina-hull',
  'sofinamalton.thingtrax.com': 'sofinamalton',
  'vitacressherbs.thingtrax.com': 'vitacressherbs',
  'zertusukfakenham.thingtrax.com': 'zertusukfakenham',
  'pc.thingtrax.com': 'pc',
  'bnb.thingtrax.com': 'bnb',
  'mytongadbrook.thingtrax.com': 'mytongadbrook',
  'becketts.thingtrax.com': 'becketts',
  'wbc.thingtrax.com': 'wbc',
  'ht.thingtrax.com': 'ht',
  'hfukbm.thingtrax.com': 'hfukbm',
  'sofinafraserburgh.thingtrax.com': 'sofinafb',
  'mbc2.thingtrax.com': 'mbc2',
  'gbmaidstone.thingtrax.com': 'gbmaidstone',
  'nutritiongroup.thingtrax.com': 'nutritiongroup',
  'avara-tf.thingtrax.com': 'avara-tf',
  'vb.thingtrax.com': 'vb',
  'abppenston.thingtrax.com': 'abppenston',
  'cl.thingtrax.com': 'cl',
  'abpel.thingtrax.com': 'abpel',
  'aquascot2.thingtrax.com': 'aquascot2',
  'quin2.thingtrax.com': 'quin2'

};

export const getEnvDetail = () => {
  const envKey = window.location.hostname;
  const env = hostnameToEnv[envKey] || 'default';
  return envData[env];
};

export const Role = {
  VIEWER: 'Viewer',
  SUPERVISOR: 'Supervisor',
  ADMIN: 'Admin',
  SETTER: 'Setter',
  PLANNER: 'Planner',
  GLOBAL_VIEWER: 'GlobalViewer',
  GLOBAL_ADMIN: 'GlobalAdmin',
  ROCHECELL_VIEWER: 'RocheCellViewer',
};
